import { EntityApiService } from '@dfl/react-security';
import { IFaq } from 'modules/cms/faq/interfaces';

class FaqService extends EntityApiService<IFaq> {}

export default new FaqService('/ms-cms/api/faq');
